import { iErrorEvent, iErrorEventHandler } from './emitter';

export class ConsoleErrorLogger implements iErrorEventHandler {
  constructor() {}

  handle(event: iErrorEvent): void {
    let log = `[ERROR] ${event.error}`;
    if (event.message) {
      log += `\nMessage: ${event.message}`;
    }
    if (event.context) {
      log += `\nContext: ${JSON.stringify(event.context)}`;
    }
    console.error(log);
  }
}
